import { LOGIN_SUCCESS, SET_USER_DATA } from './loginTypes';

const initialState = {
  token: '',
  user_id: '',
  product: '',
  userData: {},
  docChatQuota: null,
  docCompareQuota: null,
};

export const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.data.token,
        user_id: action.payload.data.user_id,
        product: action.product,
      };
    case SET_USER_DATA:
      return {
        ...state,
        user_id: action.payload.user_id,
        token: action.payload.token,
        userData: action.payload?.userData,
        docChatQuota: action.payload?.userData?.contractUserSetting?.userSubscriptions?.find(
          (item) => item?.service === 'DOCCHAT'
        )?.quota,
        docCompareQuota: action.payload?.userData?.contractUserSetting?.userSubscriptions?.find(
          (item) => item?.service === 'DOCCOMPARE'
        )?.quota,
      };
    default:
      return state;
  }
};

export const loginStateSelector = (state) => state.loginState;
export const userDataSelector = (state) => state.loginState.userData;
